import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import PageHeader from "../../../shared/components/PageHeader";
import { getInstitution } from "../actions/institution.actions";
import ViewInstitutionPage from "./components/ViewInstitutionPage";

const ViewInstitution = props => {
  const { dispatch, institution } = props;

  function fetchInstitution() {
    dispatch(getInstitution(props.match.params.id));
  }

  useEffect(() => {
    if (props.match.params.id) {
      
      dispatch(getInstitution(props.match.params.id));
    }
  }, [dispatch, props.match.params.id]);

  return (
    <Container>
      <PageHeader header="View Institution" subheader="View institution details" />
      <Row>
        <ViewInstitutionPage
          institutionId={props.match.params.id}
          institution={institution}
          fetchData={fetchInstitution}
        />
      </Row>
    </Container>
  );
};

export default connect(state => ({
  institution: state.viewInstitution
}))(ViewInstitution);
